import { css } from '@emotion/core';
import { variables as vars } from '@domain-group/fe-brary';
import { smallFontSize } from '../../styles/variables';
var font = vars.font,
  colour = vars.colour,
  global = vars.global;
export var badges = /*#__PURE__*/css("position:absolute;top:0;left:0;font-family:", font.bodyFontFamily, ";font-size:", smallFontSize, ";line-height:", font.smallLineHeight, ";color:", colour.white, ";z-index:", global.layerReset, ";border-radius:2px;");